<template>
  <div>
    <b-card>
      <b-table
        responsive
        :items="criteriosLocal"
        :fields="fields"
        striped
        show-empty
        hover
        stacked="lg"
      >
        <template #cell(atributos)="data">
          <ul class="lista-atributos-serigy">
            <li
              v-for="(atbt, index) in data.item.atributos"
              :key="index"
              class="atributo-item-serigy"
            >
              <span class="atributo-text-serigy">
                {{ ajustaStringAtributos(atbt.atributoDs) }}
              </span>

              <div class="atributo-actions-serigy">
                <b-form-checkbox
                  v-model="atbt.pontoGeral"
                  name="check-button"
                  switch
                  :disabled="
                    data.item.temRespostaAuditor ||
                    (data.item.temRespostaAuditor &&
                      atbt.cpfAuditor !== cpfAuditor &&
                      atbt.cpfAuditor !== null)
                  "
                  @change="mudaPontoAtribAuditor(atbt, data.item.id)"
                />

                <b-dropdown right no-caret class="m-1">
                  <template #button-content>
                    <font-awesome-icon icon="bars" />
                  </template>
                  <b-dropdown-item @click="openAnaliseModal(atbt)">
                    <font-awesome-icon icon="file-circle-check" />
                    <span> Análise</span>
                  </b-dropdown-item>
                  <b-dropdown-item @click="openImageModal(atbt)">
                    <font-awesome-icon icon="image" />
                    <span> Imagem</span>
                  </b-dropdown-item>
                  <b-dropdown-item
                    @click="
                      openObsModal(
                        atbt,
                        data.item.id,
                        data.item.temRespostaAuditor
                      )
                    "
                  >
                    <font-awesome-icon icon="circle-info" />
                    <span> Observações</span>
                  </b-dropdown-item>
                </b-dropdown>
              </div>
            </li>
          </ul>
        </template>

        <template #cell(validations)="criterio">
          <span
            class="d-inline-block"
            tabindex="0"
            v-b-popover.html.hover.top="
              criterio.item.temRespostaAuditor &&
              cpfAuditor !== criterio.item.cpfAuditor
                ? getConteudoPopover(criterio.item.id, criterio.item.cpfAuditor)
                : getConteudoPopover(criterio.item.id)
            "
            :title="titlePopover"
          >
            <b-button
              v-if="criterio.item.temRespostaAuditor"
              :disabled="
                loadingValidacao || cpfAuditor !== criterio.item.cpfAuditor
              "
              size="sm"
              @click="alertaRemoveRespostas(criterio.item)"
            >
              Validado
              <font-awesome-icon icon="check" />
            </b-button>

            <b-button
              v-else
              :disabled="loadingValidacao"
              size="sm"
              variant="outline-secondary"
              @click="validarCriterio(criterio.item)"
            >
              Validar
              <font-awesome-icon icon="check" />
            </b-button>
          </span>
        </template>

        <template #cell(show_details)="row">
          <b-link class="text-dark" @click="row.toggleDetails">
            <font-awesome-icon
              :icon="row.detailsShowing ? 'chevron-down' : 'chevron-right'"
            />
          </b-link>
        </template>
      </b-table>
    </b-card>

    <ModalObservacaoSerigy
      v-if="modalAberto"
      :atributo="atributoObs"
      :disabled="disabledModal"
      @close="closeModal"
      @atualiza="atualiza"
    />

    <VueEasyLightbox
      :visible="modalImagemAberto"
      :imgs="image"
      @hide="onHideImage"
    />
  </div>
</template>

<script lang="ts">
import { PropType } from "vue";
import { UtilsTS } from "@/utilsts";
import { mixins } from "vue-class-component";
import { TableField } from "@/types/table-field";
import { Component, Vue } from "vue-property-decorator";
import { fieldsRespostasSerigy } from "@/types/administracao/serigy/fields-respostas-serigy";
import { CriterioSerigy } from "@/types/administracao/serigy/criterio-serigy";
import { AtributoSerigy } from "@/types/administracao/serigy/atributo-serigy";
import { EnumTipoAnaliseId } from "@/types/administracao/serigy/enum-tipo-analise-id";
import { RespostaDetalheSerigy } from "@/types/administracao/serigy/resposta-detalhe-serigy";
import serigyService from "@/services/administracao/serigyService";
import ModalObservacaoSerigy from "./ModalObservacaoSerigy.vue";
import VueEasyLightbox from "vue-easy-lightbox";
import { RespostasOutrasAvaliacoes } from "@/types/administracao/serigy/respostas-outras-avaliacoes";
import { AuditoresDiferentes } from "@/types/administracao/serigy/auditores-diferentes";

const CompProps = Vue.extend({
  name: "TabelaValidacoesSerigy",
  components: {
    ModalObservacaoSerigy,
    VueEasyLightbox,
  },
  props: {
    criterios: {
      type: Array as PropType<CriterioSerigy[]>,
      default: () => [],
      required: true,
    },
    respostasOutrasAvaliacoes: {
      type: Array as PropType<RespostasOutrasAvaliacoes[]>,
      default: () => [],
      required: true,
    },
    nomeAuditoresDiferentes: {
      type: Array as PropType<AuditoresDiferentes[]>,
      default: () => [],
      required: true,
    },
    idAvaliacao: {
      type: Number,
      required: true,
      default: 0,
    },
  },
});

@Component
export default class TabelaValidacoesSerigy extends mixins(UtilsTS, CompProps) {
  fields: TableField[] = fieldsRespostasSerigy;
  modalAberto = false;
  atributoObs = new AtributoSerigy();
  modalImagemAberto = false;
  image: string[] = [];
  cpfAuditor: string | null = null;
  disabledModal = false;
  loadingValidacao = false;

  criteriosLocal: CriterioSerigy[] = [];
  respOutrasAvaLocal: RespostasOutrasAvaliacoes[] = [];
  titlePopover: string | undefined = undefined;

  mounted() {
    this.criteriosLocal = [...this.criterios];
    this.cpfAuditor = localStorage.getItem("cpf");
  }

  getConteudoPopover(
    criterioId: number,
    cpfAuditor?: string
  ): string | undefined {
    if (cpfAuditor) {
      const nomeAuditor = this.nomeAuditoresDiferentes.find(
        (a) => a.cpfAuditor === cpfAuditor
      )?.nomeAuditor;
      this.titlePopover = "Critério validado por outro auditor:";
      const resposta = [`Auditor: ${nomeAuditor}`].join("<br/>");
      return resposta;
    }
    const respostaOutrasAva = this.respostasOutrasAvaliacoes.find(
      (r) => r.criterioId === criterioId
    );
    if (!respostaOutrasAva) {
      this.titlePopover = undefined;
      return undefined;
    }
    this.titlePopover = "Critério já validado:";
    const resposta = [
      `Data da avaliação: ${this.formatData(respostaOutrasAva?.dhAvaliacao)}.`,
      `Data da resposta: ${this.formatData(respostaOutrasAva?.dhResposta)}.`,
      `Auditor: ${respostaOutrasAva?.nomeAuditor ?? ""}`,
    ].join("<br/>");
    return resposta;
  }

  mudaPontoAtribAuditor(atributo: AtributoSerigy, criterioId: number) {
    const respostaAuditor = atributo.respostas.find(
      (r) => r.tipoAnaliseId === EnumTipoAnaliseId.AUDITOR
    );
    if (respostaAuditor) {
      respostaAuditor.ponto = atributo.pontoGeral;
      atributo.respostas.splice(
        atributo.respostas.findIndex(
          (r) => r.tipoAnaliseId === EnumTipoAnaliseId.AUDITOR
        ),
        1,
        respostaAuditor
      );
    } else {
      const respostaAnterior = atributo.respostas[0];
      const novaResposta = new RespostaDetalheSerigy({
        criterioAtributoId: respostaAnterior.criterioAtributoId,
        tipoAnaliseId: EnumTipoAnaliseId.AUDITOR,
        cpfAuditor: null,
        linkEvidencia: respostaAnterior.linkEvidencia ?? null,
        txtAnalise: respostaAnterior.txtAnalise ?? null,
        ponto: atributo.pontoGeral,
        dhResposta: null,
        linkPrint: respostaAnterior.linkPrint ?? null,
      });
      atributo.respostas.push(novaResposta);
      atributo.criterioId = criterioId;
    }
    this.atualiza(atributo);
  }

  alertaRemoveRespostas(criterio: CriterioSerigy) {
    this.$bvModal
      .msgBoxConfirm(`Deseja remover o critério: "${criterio.criterioDs}" ?`, {
        buttonSize: "sm",
        cancelTitle: "Cancelar",
        cancelVariant: "outline-secondary",
        okVariant: "secondary",
        centered: true,
        headerBgVariant: "secondary",
        headerTextVariant: "light",
        okTitle: "Confirmar",
        title: "Remover respostas do auditor",
      })
      .then(async (value) => {
        if (value) await this.desvalidarCriterio(criterio.id);
      })
      .catch((err) => {
        console.error(
          `Erro ao operar o dialog de alerta de remoção de critério`,
          err
        );
      });
  }

  async desvalidarCriterio(criterioId: number) {
    try {
      this.loadingValidacao = true;
      await serigyService.desvalidarCriterio(this.idAvaliacao, criterioId);
      this.reload();
      this.$toast.success("Apagado com sucesso!");
    } catch (error: unknown) {
      this.tratarError(error);
    } finally {
      this.loadingValidacao = false;
    }
  }

  async validarCriterio(criterio: CriterioSerigy) {
    try {
      this.loadingValidacao = true;
      criterio = new CriterioSerigy(criterio);
      if (
        !criterio.atributos.every((a) =>
          a.respostas.some((r) => r.tipoAnaliseId === EnumTipoAnaliseId.AUDITOR)
        )
      ) {
        criterio.atributos.forEach((atributo) => {
          const temRespostaAuditor = atributo.respostas.some(
            (r) => r.tipoAnaliseId === EnumTipoAnaliseId.AUDITOR
          );
          if (!temRespostaAuditor) {
            const respostaAnterior = atributo.respostas[0];
            const novaResposta = new RespostaDetalheSerigy({
              criterioAtributoId: respostaAnterior.criterioAtributoId,
              tipoAnaliseId: EnumTipoAnaliseId.AUDITOR,
              cpfAuditor: null,
              linkEvidencia: respostaAnterior.linkEvidencia ?? null,
              txtAnalise: respostaAnterior.txtAnalise ?? null,
              ponto: atributo.pontoGeral,
              dhResposta: null,
              linkPrint: respostaAnterior.linkPrint ?? null,
            });
            atributo.respostas.push(novaResposta);
          }
        });
        criterio = new CriterioSerigy(criterio);
      }
      const arrayRespostas = criterio.atributos.flatMap((at) =>
        at.respostas.filter(
          (rp) => rp.tipoAnaliseId === EnumTipoAnaliseId.AUDITOR
        )
      );
      await serigyService.postResposta(this.idAvaliacao, arrayRespostas);
      this.reload();
      this.$toast.success("Validado com sucesso!");
    } catch (e: unknown) {
      this.tratarError(e);
    } finally {
      this.loadingValidacao = false;
    }
  }

  reload() {
    this.$emit("reload");
  }

  atualiza(novoAtributo: AtributoSerigy) {
    // Encontrar critério e atributo para atualizar as respostas localmente
    const indexCriterio = this.criteriosLocal.findIndex(
      (c) => c.id === novoAtributo.criterioId
    );
    if (indexCriterio === -1) {
      this.$toast.error("Erro ao encontrar o critério.");
      return;
    }
    const criterio = this.criteriosLocal[indexCriterio];
    // Se o critério for encontrado...
    const indexAtrib = criterio.atributos.findIndex(
      (a) => a.id === novoAtributo.id
    );
    if (indexAtrib === -1) {
      this.$toast.error("Erro ao encontrar o atributo.");
      return;
    }

    criterio.atributos.splice(indexAtrib, 1, novoAtributo);
    this.criteriosLocal.splice(indexCriterio, 1, criterio);
    // this.$emit('input', this.criteriosLocal) // descomentar em caso de emergência
  }

  openObsModal(
    atributo: AtributoSerigy,
    criterioId: number,
    temRespostaAuditorCriterio: boolean
  ) {
    this.disabledModal =
      temRespostaAuditorCriterio ||
      (temRespostaAuditorCriterio &&
        atributo.cpfAuditor !== this.cpfAuditor &&
        atributo.cpfAuditor !== null);
    this.modalAberto = true;
    this.atributoObs = new AtributoSerigy(atributo);
    this.atributoObs.criterioId = criterioId;
  }

  closeModal() {
    this.modalAberto = false;
    this.disabledModal = false;
  }

  async openImageModal(atributo: AtributoSerigy) {
    try {
      const response = await serigyService.downloadPrint(
        atributo.respostas[0].id
      );      
      const imageUrl = URL.createObjectURL(response);
      this.image = [imageUrl];
      this.modalImagemAberto = true;
    } catch (e: unknown) {      
      this.tratarError(e);
    }
  }

  onHideImage() {
    if (this.image.length) {
      URL.revokeObjectURL(this.image[0]);
    }
    this.modalImagemAberto = false;
    this.image = [];
  }

  openAnaliseModal(atributo: AtributoSerigy): void {
    const respostaIA = atributo.respostas.find(
      (r) => r.tipoAnaliseId === EnumTipoAnaliseId.IA && r.txtAnalise
    );
    if (respostaIA) {
      this.$bvModal.msgBoxConfirm(`${respostaIA.txtAnalise}`, {
        centered: true,
        headerBgVariant: "secondary",
        headerTextVariant: "light",
        title: "Análise Serigy IA",
        footerClass: "d-none",
        bodyClass: "text-break",
      });
      return;
    }
    this.$toast.error("Não há resposta de IA.");
  }

  ajustaStringAtributos(txt: string): string {
    return this.capitalize(txt.split(" (")[0]);
  }
}
</script>

<style scoped>
.lista-atributos-serigy {
  list-style: none;
  margin: 0;
  padding: 0;
}

.atributo-item-serigy {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 0.5rem;
  flex-wrap: wrap;
}

.atributo-text-serigy {
  flex: 1 1 12rem;
  min-width: 0;
  text-align: left;
  word-break: break-word;
}

.atributo-actions-serigy {
  display: flex;
  align-items: center;
  margin-left: auto;
}

@media screen and (max-width: 991.98px) {
  .atributo-item-serigy {
    align-items: flex-start;
  }

  .atributo-actions-serigy {
    margin-left: 0;
  }
}
</style>
